import { NgClass, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { DotCMSNavigationItem } from 'dotcms/src/lib/models';

import { DomService } from 'ish-core/utils/dom/dom.service';

import { dotCMSNavigationLink, isIndexPagePresent } from '../../../utils/dot-cms-uve-utils';

@Component({
  selector: 'custom-dot-cms-uve-header-folder-index-page-check',
  templateUrl: './dot-cms-uve-header-folder-index-page-check.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, NgIf, RouterLink],
})
export class DotCmsUVEHeaderFolderIndexPageCheckComponent {
  readonly navLink = input<DotCMSNavigationItem>(undefined);
  readonly depth = input<number>(undefined);
  readonly dropDownLayer = input<number>(undefined);
  readonly deviceType = input<string>(undefined);

  isHavingIndexPage = isIndexPagePresent;
  dotCMSHeaderNavigationLink = dotCMSNavigationLink;

  constructor(private domService: DomService) {}

  hideFlyout(id: number) {
    this.domService.getElementById(`dot-cms-header-flyout${id}`).classList.add('d-none');
  }
}
